import { render, staticRenderFns } from "./step-contacts-seller-type-mobile.vue?vue&type=template&id=6565fa07"
import script from "./step-contacts-seller-type-mobile.vue?vue&type=script&lang=ts"
export * from "./step-contacts-seller-type-mobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports